module.exports = __webpack_public_path__ + "static/media/6.ce1caa1a.jpg";